<template>
  <v-container>
    <v-card>
      <v-card-text>
        <div class="mt-3 mb-1">■出力画像</div>
        <v-layout row wrap>
          <v-flex sm4>
            <v-select
              v-model="outputImageType"
              label="出力画像形式（output_image_type）"
              :items="[
                { text: '出力しない：none', value: 'none' },
                { text: 'TIFF形式で出力：tiff', value: 'tiff' },
                { text: 'TIFFとPDFで出力：tiff_pdf', value: 'tiff_pdf' }
              ]"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>
        </v-layout>

        <div class="mt-3 mb-1">■出力画像の設定</div>
        <v-layout row wrap>
          <v-flex sm4>
            <v-select
              v-model="outputText"
              label="テキストの出力（output_text）"
              :items="[
                { text: '出力しない：off', value: 'off' },
                { text: '出力する：on', value: 'on' }
              ]"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>

          <v-flex sm4>
            <v-select
              v-model="outputFrontpageBack"
              label="表紙の裏と裏表紙の裏の出力（output_frontpage_back）"
              :items="[
                { text: '出力しない：off', value: 'off' },
                { text: '出力する：on', value: 'on' }
              ]"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>

          <v-flex sm4>
            <v-select
              v-model="outputTombo"
              label="トンボの出力（output_tombo）"
              :items="[
                { text: '出力しない：off', value: 'off' },
                { text: '出力する：on', value: 'on' }
              ]"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>

          <v-flex sm4>
            <v-select
              v-model="outputRange"
              label="出力範囲（output_range）"
              :items="[
                { text: 'ページ全体：entire_page', value: 'entire_page' },
                {
                  text: 'トンボの裁ち落としまで：bleeding_tombo',
                  value: 'bleeding_tombo'
                },
                {
                  text: 'トンボの内側まで：inside_tombo',
                  value: 'inside_tombo'
                }
              ]"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>

          <v-flex sm4>
            <v-select
              v-model="outputTone"
              label="トーン出力（output_tone）"
              :items="[
                { text: 'トーンのまま出力：tone', value: 'tone' },
                { text: 'グレーで出力：gray', value: 'gray' }
              ]"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>

          <v-flex sm4>
            <v-select
              v-model="outputStoryinfo"
              label="作品情報の出力 (output_storyinfo)"
              :items="[
                { text: '出力しない：off', value: 'off' },
                { text: '出力する：on', value: 'on' }
              ]"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>

          <v-flex sm4>
            <v-select
              v-model="outputfileText"
              label="テキストを別ファイルとして出力 (outputfile_text)"
              :items="[
                { text: '出力しない：off', value: 'off' },
                { text: '出力する：on', value: 'on' }
              ]"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>
        </v-layout>

        <div class="mt-3 mb-1">■BS形式データの出力設定</div>
        <v-layout row wrap>
          <v-flex sm4>
            <v-select
              v-model="bsOutputText"
              label="テキストの出力（bs_output_text）"
              :items="[
                { text: '出力しない：off', value: 'off' },
                { text: '出力する：on', value: 'on' }
              ]"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>

          <v-flex sm4>
            <v-select
              v-model="bsOutputFrontpageBack"
              label="表紙の裏と裏表紙の裏の出力（bs_output_frontpage_back）"
              :items="[
                { text: '出力しない：off', value: 'off' },
                { text: '出力する：on', value: 'on' }
              ]"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>

          <v-flex sm4>
            <v-select
              v-model="bsOutputTombo"
              label="トンボの出力（bs_output_tombo）"
              :items="[
                { text: '出力しない：off', value: 'off' },
                { text: '出力する：on', value: 'on' }
              ]"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>

          <v-flex sm4>
            <v-select
              v-model="bsOutputRange"
              label="出力範囲（bs_output_range）"
              :items="[
                { text: 'ページ全体：entire_page', value: 'entire_page' },
                {
                  text: 'トンボの裁ち落としまで：bleeding_tombo',
                  value: 'bleeding_tombo'
                },
                {
                  text: 'トンボの内側まで：inside_tombo',
                  value: 'inside_tombo'
                }
              ]"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>

          <v-flex sm4>
            <v-select
              v-model="bsOutputTone"
              label="トーン出力（bs_output_tone）"
              :items="[
                { text: 'トーンのまま出力：tone', value: 'tone' },
                { text: 'グレーで出力：gray', value: 'gray' }
              ]"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>

          <v-flex sm4>
            <v-text-field
              v-model="bsOutputPixelsize"
              label="出力する画像のサイズ 単位ピクセル（bs_output_pixelsize）"
              hint="数値、指定なしの場合のデフォルトは960"
              persistent-hint
            ></v-text-field>
          </v-flex>

          <v-flex sm4>
            <v-select
              v-model="bsOutputStoryinfo"
              label="作品情報の出力 (bs_output_storyinfo)"
              :items="[
                { text: '出力しない：off', value: 'off' },
                { text: '出力する：on', value: 'on' }
              ]"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>

          <v-flex sm4>
            <v-select
              v-model="bsOutputType"
              label="BS形式出力タイプ (bs_output_type)"
              :items="[
                { text: '見開き：spread', value: 'spread' },
                { text: 'Webtoon：webtoon', value: 'webtoon' }
              ]"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>
        </v-layout>

        <div class="mt-3 mb-1">■その他設定（PAINTには引き渡さない）</div>
        <v-layout row wrap>
          <v-flex sm4>
            <v-text-field
              v-model="lowestPaintVersion"
              label="最低PAINTバージョン（lowest_paint_version）"
              hint="1.8.3などの文字列"
              persistent-hint
            ></v-text-field>
          </v-flex>

          <v-flex sm4>
            <v-text-field
              v-model="lowestIceVersion"
              label="最低ICEバージョン（lowest_ice_version）"
              hint="1.8.3などの文字列"
              persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>

        <div class="mt-3 mb-1">■トークン</div>
        <v-layout row wrap>
          <v-text-field v-model="token" label="トークン"></v-text-field>
        </v-layout>

        <div v-if="isIce">
          <v-layout justify-center class="my-3">
            <v-btn color="primary" @click="openCallIce">callIce</v-btn>
          </v-layout>
          <v-textarea :value="callIceUrl" label="callIce" readonly></v-textarea>
        </div>
        <div v-else>
          <v-layout justify-center class="my-3">
            <v-btn color="primary" @click="openClipstudio"
              >CLIP STUDIO起動</v-btn
            >
          </v-layout>
          <v-textarea
            :value="clipstudioUrl"
            label="clipstudio"
            readonly
          ></v-textarea>
        </div>
      </v-card-text>
    </v-card>
    <v-card class="mt-3">
      <v-card-text>
        <div class="mt-3 mb-4">■CLIP STUDIO起動画面へのリンク</div>
        <v-layout wrap mb-2>
          <v-flex sm12 md4>
            <a :href="`/${locale}/start-clip-studio/shueisha`">
              （現行）集英社様 マンガ賞応募用
            </a>
          </v-flex>
          <v-flex sm12 md8>
            <ul>
              <li>印刷用データが出力されます。</li>
              <li>登録完了後、集英社様用の完了画面が表示されます。</li>
            </ul>
            <a href="https://celsys.gyazo.com/0c51175c1c56fca765c63684f92c6491">
              https://celsys.gyazo.com/0c51175c1c56fca765c63684f92c6491
            </a>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout wrap mt-2 mb-2>
          <v-flex sm12 md4>
            <a :href="`/${locale}/start-clip-studio/digital`">
              （現行）汎用的デジタル入稿向け
            </a>
          </v-flex>
          <v-flex sm12 md8>
            <ul>
              <li>印刷用データが出力されます。</li>
            </ul>
            <a href="https://celsys.gyazo.com/10e6e51e3559cdcc33fd68aab3ba833d">
              https://celsys.gyazo.com/10e6e51e3559cdcc33fd68aab3ba833d
            </a>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout wrap mt-2 mb-2>
          <v-flex sm12 md4>
            <a :href="`/${locale}/start-clip-studio/digital-text`">
              （新規）汎用的デジタル入稿向け<br />
              テキストを別ファイルとして出力
            </a>
          </v-flex>
          <v-flex sm12 md8>
            <ul>
              <li>印刷用データが出力されます。</li>
              <li>テキストが別ファイルとして出力されます。</li>
            </ul>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout wrap mt-2 mb-2>
          <v-flex sm12 md4>
            <a :href="`/${locale}/start-clip-studio/shueisha-text`">
              （新規）集英社様用<br />
              テキストを別ファイルとして出力
            </a>
          </v-flex>
          <v-flex sm12 md8>
            <ul>
              <li>印刷用データが出力されます。</li>
              <li>テキストが別ファイルとして出力されます。</li>
              ※「汎用的デジタル入稿向け（テキストを別ファイルとして出力）」と動作は変わりませんが、
              内部データとして、集英社様用として記録されます。
            </ul>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import ice from "../../../lib/ice";

export default {
  name: "vc-share-sample-ice-client",
  props: {
    locale: { type: String, default: "ja-jp" }
  },
  data() {
    return {
      outputImageType: "",
      outputText: "",
      outputFrontpageBack: "",
      outputTombo: "",
      outputRange: "",
      outputTone: "",
      outputStoryinfo: "",
      outputfileText: "",
      bsOutputText: "",
      bsOutputFrontpageBack: "",
      bsOutputTombo: "",
      bsOutputRange: "",
      bsOutputTone: "",
      bsOutputPixelsize: "",
      bsOutputStoryinfo: "",
      bsOutputType: "",
      lowestPaintVersion: "1.10.5",
      lowestIceVersion: "1.10.5",
      token: "",
      isIce: false
    };
  },
  mounted() {
    this.isIce = ice.isIce();
  },
  computed: {
    clipstudioUrl() {
      return this.getClipstudioUrl();
    },
    callIceUrl() {
      return this.getCallIceUrl();
    }
  },
  methods: {
    openClipstudio() {
      location.href = this.getClipstudioUrl();
    },
    openCallIce() {
      location.href = this.getCallIceUrl();
    },
    getClipstudioUrl() {
      return this.getUrl("clipstudio", "shareexport", this.getParams());
    },
    getCallIceUrl() {
      return this.getUrl("callice", "shareexport", this.getParams());
    },
    getParams() {
      return {
        token: this.token,
        output_image_type: this.outputImageType,
        output_text: this.outputText,
        output_frontpage_back: this.outputFrontpageBack,
        output_tombo: this.outputTombo,
        output_range: this.outputRange,
        output_tone: this.outputTone,
        output_storyinfo: this.outputStoryinfo,
        outputfile_text: this.outputfileText,
        bs_output_text: this.bsOutputText,
        bs_output_frontpage_back: this.bsOutputFrontpageBack,
        bs_output_tombo: this.bsOutputTombo,
        bs_output_range: this.bsOutputRange,
        bs_output_tone: this.bsOutputTone,
        bs_output_pixelsize: this.bsOutputPixelsize,
        bs_output_storyinfo: this.bsOutputStoryinfo,
        bs_output_type: this.bsOutputType,
        lowest_paint_version: this.lowestPaintVersion,
        lowest_ice_version: this.lowestIceVersion
      };
    },
    getUrl(scheme, methodName, params) {
      let uri = scheme + "://" + methodName;
      if (params) {
        for (const paramName in params) {
          if (params[paramName] != "") {
            uri +=
              "/" +
              encodeURIComponent(paramName) +
              "/" +
              encodeURIComponent(params[paramName]);
          }
        }
      }

      return uri;
    }
  }
};
</script>
